import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { AuthService } from '../services/auth.service';
import * as CryptoJS from 'crypto-js'
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit, OnChanges {
  verify: boolean = false;
  fortgotBgCover: any
  passIcon: any
  shows: boolean = false
  showBottom: boolean = false
  @Output() forgotData = new EventEmitter<any>();
  forgotForm!: FormGroup;
  otp = new FormControl('', Validators.required);
  passwordVariable: boolean = false;
  passwordForm: FormGroup;
  check: boolean = true
  validateCheck: boolean = false;
  emailResponse: boolean = false
  otpLength: any
  show = true;
  fullScreen = true;
  template = ``
  forgotPassOTP: number;
  userTxnId: any;
  SUPERSECRET: string = environment.SUPERSECRET;

  // Minimum eight characters, at least one letter, one number and one special character:
  passwordPattern = "(?=.*?[0-9])(?=.*?[#?/!@$%^&*-]).{8,}$";

  ngOnChanges(changes: SimpleChanges) {
    // this.formFields = changes['formFields']?.currentValue
    console.log('changes==>', changes);

  }
  checkVal(event: any) {
    // console.log('checkVal', event);
    this.forgotPassOTP = event;

    // console.log(event.length);
    this.otpLength = event.length
    if (this.otpLength >= 6) {
      this.validateCheck = true
    } else {
      this.validateCheck = false
    }
  }
  constructor(private router: Router, private route: ActivatedRoute, private formBuilder: FormBuilder, private service: AuthService) {

    this.passwordForm = this.formBuilder.group({
      password: ['', [Validators.required, Validators.pattern(this.passwordPattern)]],
      confirmPassword: ['', Validators.required],
    }, { validator: this.passwordMatchValidator() });

    this.service.sendResponse.subscribe((res: any) => {

      if (res) {
        console.log(this.show);

        this.emailResponse = true;
        setTimeout(() => {
          this.show = false;
        }, 500)

      }
      else {
        this.emailResponse = false
        // alert('Try after some time')
      }

    })
    this.fortgotBgCover = JSON.parse(localStorage.getItem('forgotPasswordData'))
    console.log(this.fortgotBgCover);

    // this.service.receiveForgotData.subscribe((res:any)=>{
    //   console.log(res);
    //   this.fortgotBgCover = res
    // })
  }
  //   search(term: string): void {
  //     console.log(term);
  //     // term == this.emailResponse?.id ? this.validateCheck = true : this.validateCheck = false
  //  }

  ngOnInit(): void {
    this.createForm();
  }

  password() {
    this.shows = !this.shows;
  }

  passwordBottom() {
    this.showBottom = !this.showBottom;
  }
  validate() {
    // console.log(this.otp.value);
    console.log(this.forgotForm.value.email);

    console.log(this.forgotPassOTP);
    let apiData = {
      "otpTxnId": this.userTxnId,
      "email": this.forgotForm.value.email,
      "otp": this.forgotPassOTP
    }
    this.service.forgotPassVerifyOTP(apiData).subscribe((response: any) => {
      console.log('forgotPassVerifyOTP', response);
      this.verify = false;
      this.check = false;
      Swal.fire('Success', 'OTP verified successfully', 'success').then(() => {
        if (this.otp.value && this.otp.value.length) {
          this.passwordVariable = true;
        } else {
          this.passwordVariable = false;
          this.check = true
        }
      });
    },
      (error) => {
        Swal.fire('Error', error.error.message, 'error')
      })


    //CS Code
    this.service.otp.next(this.otp.value)

  }

  otpEnter(value) {
    console.log('value', value);

  }

  createForm() {

    this.forgotForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email], this.forbiddenEmails),
      // facility_name: new FormControl('', [Validators.required]),
    });
  }
  forbiddenEmails(control: FormControl): Promise<any> | Observable<any> {
    const promise = new Promise<any>((resolve, reject) => {
      setTimeout(() => {
        if (control.value === 'test@test.com') {
          resolve({ 'emailIsForbidden': true });
        }
        else {
          resolve(null);
        }

      }, 500);
    });
    return promise;
  }
  get form() {
    return this.forgotForm?.controls
  }

  get emailForm() { return this.forgotForm.controls; }

  onSubmit() {
    this.show = true;
    this.fullScreen = true;
    this.template = ``
    console.log(this.forgotForm.value);
    let payloadData = { ...this.forgotForm.value, "forgot_password": true }
    console.log('payloadData', payloadData);

    this.service.forgotPassword(payloadData).subscribe((response: any) => {
      console.log('forget has called');
      this.userTxnId = response.data.otpTxnId;
      this.verify = true;
    },
      (error) => {
        console.log('error', error.error.message);

        Swal.fire('Error', error.error.message, 'error')
      })
    // this.service.changeData.next({ key: this.forgotForm?.value?.email })
  }

  savePassowrd() {
    console.log(this.passwordForm.value)
    let passwordHash = CryptoJS.HmacSHA256(this.passwordForm.value.password, this.SUPERSECRET).toString();
    console.log('passwordHash',passwordHash);

    let apiData = {
      "otpTxnId": this.userTxnId,
      "email": this.forgotForm.value.email,
      "password": passwordHash,
    }

    this.service.setNewPassword(apiData).subscribe((response) => {
      console.log('new password response', response);
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Password changed successfully!',
      })
    },
      (error) => {
        Swal.fire('Error', error.error.message, 'error');
      }
    )
    // console.log(this.otp.value);
    // let obj = {
    //   otp: this.otp.value
    // }
    // this.service.allDetails.next({ ...this.passwordForm.value, ...this.forgotForm.value, ...obj })

    this.router.navigate(['/login'])
  }

  passwordMatchValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const password = control.get('password');
      const confirmPassword = control.get('confirmPassword');

      return password.value === confirmPassword.value ? null : { passwordMismatch: true };
    };
  }
}
